// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3NwPG","title":"Info_title__TIocH","selects":"Info_selects__2nF0Q","requiredAsterisk":"Info_requiredAsterisk__sXMaN"};